import VideoJsPlayer from "@/components/VideoJsPlayer";
import SwitchCheckbox from "@/components/SwitchCheckbox";
import FlyingHeart from "@/components/FlyingHeart";
import ChatBox from "@/components/ChatBox";
import AnimationHeart from "@/components/AnimationHeart";
import ViewLikeCount from "@/components/ViewLikeCount";
import SeekbarVideo from "@/components/SeekbarVideo";
import HelperMixins from "@/mixins/HelperMixins";
import { mapActions, mapGetters } from "vuex";
import ClipboardJS from "clipboard";
import { ENV_CONFIGS } from "@/configs/Settings";
import { SDK_API } from "@/configs/APIs";
import ChannelStreamMixins from "@/mixins/ChannelStreamMixins";
import { DEFAULT_VALUES, RESOLUTION, STATUS_RESPONSES, TOKEN_TYPES } from "@/configs/SDK";
import EndStreamScreen from "@/components/EndStreamScreen";
import SdkMixins from "@/mixins/SdkMixins";
import { SYSTEM_MESSAGES } from "@/messages/System";

function defaultQuality() {
   return [
      { text: "High", height: 0, selected: false },
      { text: "Medium", height: 0, selected: false },
      { text: "Low", height: 0, selected: false },
      { text: "Auto", height: "auto", selected: true }
   ];
}

export default {
   name: "WatchStream",
   components: { EndStreamScreen, VideoJsPlayer, SwitchCheckbox, FlyingHeart, ChatBox, ViewLikeCount, SeekbarVideo, AnimationHeart },
   mixins: [SdkMixins, ChannelStreamMixins, HelperMixins, SdkMixins],
   data() {
      return {
         message: "",
         showComment: true,
         showDropdownMenu: false,
         showAds: true,
         clipboard: null,
         showingDebug: false,
         isShowDebug: ENV_CONFIGS.IS_SHOW_DEBUG,
         eventKey: this.$route.params.slug,
         event: {},
         itemStream: {},
         listQuality: defaultQuality(),
         videoDuration: 0,
         currentPlayingTime: 0,
         isLive: false,
         isShowResumeVideo: false
      };
   },
   watch: {
      $route(from, to) {
         console.log({ from, to });
      }
   },
   computed: {
      ...mapGetters(["getAllLikeCount", "streamStatistic", "streamDetail", "isLoggedIn", "streamEnded"]),
      getCurrentLink() {
         return `${window.location.origin}`;
      },
      getSelectedQuality() {
         return this.listQuality?.find((quality) => quality.selected)?.text || null;
      },
      getListQuality() {
         return this.listQuality.filter((quality) => quality.height > 0 || quality.height === "auto");
      }
   },
   created() {
      window.addEventListener("resize", this.setVideoBoxHeight);
   },
   async mounted() {
      if (!this.isLoggedIn) {
         if (this.isInIframe) {
            this.initIframeListener();
         } else {
            await this.saveCurrentPageName("WatchStream", {
               slug: this.eventKey
            });
            this.$nextTick(() => {
               location.replace(encodeURI(this.getLoginURL));
            });
         }
         return;
      }

      this.initPageData();
   },
   methods: {
      ...mapActions(["updateStreamDetail", "updateLimitChatConfigs", "updateStreamEnded", "updateStreamStatistic"]),
      initPageData() {
         this.getEventDetail();
         this.initClipboard();
         this.$root.$on("showToast", (mess) => {
            this.notification(mess);
         });
         this.$root.$on("host-end-stream", () => {
            this.updateStreamEnded(true);
         });
      },
      initIframeListener() {
         const messageType = {
            RAKUTEN_QUERY: "RAKUTEN_QUERY",
            COUNTRY: "COUNTRY",
            CHECK_LOGIN: "CHECK_LOGIN",
            NOT_LOGGED_IN: "NOT_LOGGED_IN"
         };
         parent.postMessage(
            JSON.stringify({
               type: "COUNTRY",
               payload: this.country
            }),
            process.env.VUE_APP_ALLOW_ORIGIN
         );

         window.onmessage = async (e) => {
            if (e.origin !== process.env.VUE_APP_ALLOW_ORIGIN || !e.data) return;
            const dataJson = JSON.parse(e.data);
            switch (dataJson.type) {
               case messageType.RAKUTEN_QUERY:
                  {
                     this.$router.replace(`${this.$route.path}${dataJson.payload}`);
                     const { e, expires_in, source } = this.$route.query;
                     if (e) {
                        const dataLogin = await this.login({
                           beliveId: e.replace(/\s/g, "+"),
                           signInType: source === "japan" ? 0 : 1,
                           expires: expires_in
                        });
                        parent.postMessage(
                           JSON.stringify({
                              type: "BELIVE_ID",
                              payload: dataLogin.accessToken
                           }),
                           process.env.VUE_APP_ALLOW_ORIGIN
                        );
                        this.$router.replace(this.$route.path);
                        //this.initPageData();
                     }
                  }
                  break;
               case messageType.CHECK_LOGIN:
                  await this.checkIsLoggedIn(dataJson.payload);
                  break;
               case messageType.NOT_LOGGED_IN:
                  this.$http
                     .post(SDK_API.EVENT_DETAIL, {
                        slug: this.eventKey
                     })
                     .then(({ data: { code, data } }) => {
                        if (code === STATUS_RESPONSES.SUCCESS) this.event = data;
                     });
                  break;
               default:
                  break;
            }
         };
      },
      async loadedMetaData(data) {
         this.videoDuration = data.duration ? parseFloat(data.duration) : 0;
         this.isLive = data.isLive;
         this.setVideoBoxHeight();
      },
      handleUpdateUrlPlaying(url) {
         this.updateUrlPlaying(url);
         this.listQuality = defaultQuality();
      },
      changeVideoQuality(height) {
         this.$refs.videoJsPlayer?.debounceChangeVideoQuality(height);
         this.listQuality.map((quality) => {
            quality.selected = quality.height == height;
            return { ...quality };
         });
      },
      addQualityLevel(qualityLevel) {
         for (let res in RESOLUTION) {
            if (RESOLUTION[res][0] <= qualityLevel.height && qualityLevel.height <= RESOLUTION[res][1]) {
               let currentQuality = this.listQuality.find((item) => item.text.toUpperCase() === res.toUpperCase());
               if (currentQuality.height < qualityLevel.height) currentQuality.height = qualityLevel.height;
            }
         }
      },
      setPlayer(status) {
         if (status) {
            this.$refs.videoJsPlayer.resumeVideo();
         } else {
            this.$refs.videoJsPlayer.pauseVideo();
         }
      },
      setTimePlayer(currentTime) {
         this.$refs.videoJsPlayer.updateCurrentTimePlaying(currentTime);
      },
      getEventDetail() {
         this.$http
            .post(SDK_API.JOIN_EVENT, {
               slug: this.eventKey
            })
            .then((response) => {
               if (response.data.code === STATUS_RESPONSES.SUCCESS) {
                  if (!response.data.data.starting) {
                     this.updateStreamEnded(true);
                  } else {
                     let streamDetail = response.data.data;
                     if (ENV_CONFIGS.IS_HARD_URL) {
                        streamDetail = Object.assign(streamDetail, {
                           baseUrl: DEFAULT_VALUES.BASE_URL
                        });
                     }
                     this.updateStreamStatistic({
                        enable_chat: streamDetail.enableChat !== null && streamDetail.enableChat !== undefined ? streamDetail.enableChat : true
                     });
                     this.updateStreamDetail(streamDetail);
                     this.updateLimitChatConfigs({
                        rtmLimiterRate: this.streamDetail.rtmLimiterRate,
                        rtmThresholdSec: parseInt(this.streamDetail.rtmThresholdSec),
                        rtmWaitingSec: this.streamDetail.rtmWaitingSec
                     });

                     // Parse token:
                     if (ENV_CONFIGS.IS_HARD_URL) {
                        this.videoTokens = Object.assign(this.videoTokens, {
                           token: DEFAULT_VALUES.TOKEN,
                           type: TOKEN_TYPES.AKAIMA
                        });
                     } else {
                        if (response.headers && response.headers.a_token) {
                           this.videoTokens = Object.assign(this.videoTokens, {
                              token: response.headers.a_token,
                              type: TOKEN_TYPES.AKAIMA
                           });
                        } else if (response.headers && response.headers.j_token) {
                           this.videoTokens = Object.assign(this.videoTokens, {
                              token: response.headers.j_token,
                              type: TOKEN_TYPES.JWT
                           });
                        }
                     }

                     this.getChatChannel();
                     this.getVideoSources();
                  }
               } else if (response.data.code === STATUS_RESPONSES.NOT_BUY_TICKET) {
                  if (this.isInIframe)
                     parent.postMessage(
                        JSON.stringify({
                           type: "LOGIN_FAILED"
                        }),
                        process.env.VUE_APP_ALLOW_ORIGIN
                     );
                  else
                     this.$router.push({
                        name: "EventPage",
                        params: {
                           id: this.eventKey
                        }
                     });
               } else if (response.data.code === STATUS_RESPONSES.USER_LOGGED_ANOTHER_DEVICE) {
                  if (this.isInIframe)
                     parent.postMessage(
                        JSON.stringify({
                           type: "LOGIN_FAILED"
                        }),
                        process.env.VUE_APP_ALLOW_ORIGIN
                     );
                  else
                     this.$router.push({
                        name: "EventPage",
                        params: {
                           id: this.eventKey
                        }
                     });
               }
            })
            .catch(() => {
               // this.$toastr.e(SYSTEM_MESSAGES.CONTACT_ADMIN, STATUS_MESSAGES.ERROR);
               if (this.isInIframe)
                  parent.postMessage(
                     JSON.stringify({
                        type: "LOGIN_FAILED"
                     }),
                     process.env.VUE_APP_ALLOW_ORIGIN
                  );
               else
                  this.$router.push({
                     name: "LandingPage"
                  });
            });
      },
      setVideoBoxHeight() {
         if (!this.$el.querySelector) return;
         const videoBoxHeight = this.$el.querySelector(".watch-stream__video-box").offsetHeight;
         const officialBtnHeight = this.$el.querySelector(".watch-stream__banner") ? this.$el.querySelector(".watch-stream__banner").offsetHeight : 0;
         document.documentElement.style.setProperty("--videoBoxHeight", `${videoBoxHeight + officialBtnHeight + 10}px`);
      },
      initClipboard() {
         this.clipboard = new ClipboardJS("#share-icon-btn");
         this.clipboard.on("success", (e) => {
            this.notification(SYSTEM_MESSAGES.URL_SHARED_MESSAGE);
            e.clearSelection();
         });
      },
      gotoShop() {
         window.open(this.streamDetail.artistShopUrl, "_blank");
      },
      handleFullscreen() {
         this.$refs.videoJsPlayer.player.requestFullscreen();
         this.$refs.videoJsPlayer.player.controls(true);
      },
      handleExitFullscreen() {
         this.$refs.videoJsPlayer.player.controls(false);
      },
      hideMenu() {
         this.showDropdownMenu = false;
      },
      onHandleLiked(isLike) {
         this.$refs.chatBox.sendLikeMsg(isLike);
      },
      onTimeVideoUpdate(time) {
         this.currentPlayingTime = time.currentTime;
      },
      afterGetVideoSources() {},
      async leaveStream() {
         if (!this.streamDetail?.viewSessionId || !this.streamDetail?.viewSessionId) return;
         const {
            data: { code }
         } = await this.$http.post(SDK_API.LEAVE_EVENT, {
            userId: this.streamDetail.viewSessionId,
            slug: this.streamDetail.slug
         });
         if (code === STATUS_RESPONSES.SUCCESS) {
            this.isCallLeaveApi = true;
         }
      },
      updateStateShowResumeVideo(val) {
         this.isShowResumeVideo = val;
      },
      resumePlayVideo() {
         this.$refs.videoJsPlayer.resumeVideo();
      }
   },
   async beforeDestroy() {
      await this.leaveStream();
      this.clipboard?.destroy();
      window.removeEventListener("resize", this.setVideoBoxHeight);
   }
};
